import { Reducers } from '@sda/enums/store';
import { PrivateMessageMask } from '@sda/sdk/masks';
import { SDK } from './helpers/sdk';
import type { FirestoreClientData } from './interfaces';
import type { Message } from '@sda/interfaces/message';

/**
 * SDK Class to interact with Firestore Messages.
 */
export class Messages extends SDK<Message> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.MESSAGES);

    this.collection = this.fsh.Schema.PrivateMessages;

    this.PrivateMap = PrivateMessageMask;
  }
}
